import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { ResponseStatus } from '../../../../common';
import { LoggingService } from '../../../../shared/services/logging';
import { EfaactDataService } from '../../../efaact.data-service';
import { InvoiceSessionSetup } from './invoice-session-setup.model';

export const entityName = 'VoucherSetup';
@Injectable({ providedIn: 'root' })
export class InvoiceSessionSetupDataService extends EfaactDataService<InvoiceSessionSetup> {
    mapItems(item: InvoiceSessionSetup): InvoiceSessionSetup {
        return {
            ...item,
            id: item.Contractlistid,
            Status: {
                StatusCode: ResponseStatus.None,
                Message: null
            }
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
